import { ReactNode } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { TriangleIcon } from "../../images/TriangleIcon";

type Props = {
  expanded: boolean;
  title: string;
  titleIcon?: ReactNode;
  bodyBlock?: ReactNode;
};

export const AccordionHeader = ({
  expanded,
  title,
  titleIcon,
  bodyBlock,
}: Props) => (
  <Stack
    sx={{
      flex: 1,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#F2F2F2",
      padding: "8px 10px",
      borderRadius: "6px",
    }}
  >
    <Stack flexDirection="row" gap="8px" alignItems="center">
      {titleIcon}
      <Typography variant="body1" fontWeight={500} color="custom.textDarkBlue">
        {title}
      </Typography>
    </Stack>

    <Stack flexDirection="row" gap="8px" alignItems="center">
      {bodyBlock}
      <Box
        sx={{
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
          transition: "transform 0.3s ease",
        }}
      >
        <TriangleIcon />
      </Box>
    </Stack>
  </Stack>
);
